import { type SlashMenuConfig } from '@blocksuite/hive-widget-slash-menu';

export const codeSlashMenuConfig: SlashMenuConfig = {
  disableWhen: ({ model }) => {
    return model.flavour === 'hive:code';
  },
  items: [],
};
